module.exports = __webpack_public_path__ + "static/media/leaf_green.0ed838a1.png";